import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import DepartmentForm from '../../../components/department-form';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Notify from "../../../components/notify";
import { createDepartmentAPI } from '../../../services/api';
import './CreateNewDepartment.scss';

const CreateNewDepartment = () => {
  const [openNotification, setOpenNotification] = useState(false);
  const [errors, setErrors]                     = useState({});
  const [loading, setLoading]                   = useState(false);
  const history = useHistory();

  const handleSubmit = async (payload) => {
    try {
      setLoading(true);
      const response = await createDepartmentAPI(payload);
      setErrors({});
      setOpenNotification(true);
      setTimeout(() => {
        setLoading(false);
        history.push('/department/list');
      }, 1000);
    } catch(err) {
      const errors =
        err && Object.keys(err).length > 0
          ? err
          : { errormessage: 'Department Creation Failed !!!!' };
      setErrors(errors);
      setOpenNotification(true);
      setLoading(false);
    }
  }

  const redirectToDepartmentList = () => {
    history.push('/department/list');
  };

  return (
    <>
      <Navbar />
      <div className="min-h-full flex justify-center items-center bg-black text-white container">
        <div className="create-user container">
          <div className="flex flex-col text-center heading">
            <h2>Create Department</h2>
          </div>
          <DepartmentForm
            handleSubmit={handleSubmit}
            redirectToDepartmentList={redirectToDepartmentList}
            loading={loading}
          />
          <Notify
            open={openNotification}
            onClose={() => setOpenNotification(false)}
            errors={errors}
          />
        </div>
      </div>
      <Footer />
    </>
  );
}

export default CreateNewDepartment;